<template>
  <div class="container">
    <div class="row">
        <div class="col" v-if="gameOver == false">Current Score</div>
        <div class="col" v-else>Final Score</div>
        <div
        class="col"
        v-for="player in players"
        :key="player.name"
        >{{scores[player.name].score}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "totals",
  props: {
      players: Array,
      scores: {},
      gameOver: Boolean
  }
}
</script>

<style scoped>
.container {
  display: flex; /* or inline-flex */
  flex-direction: column;
}

.row {
  display: flex; /* or inline-flex */
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: space-around;
  align-content: center;
  justify-content: space-between;
}
.row > * {
  flex: 1 100%;
}

.col {
  padding: 5px;
  
  line-height: 15px;
  font-weight: bold;
  font-size: 1em;
  text-align: center;
}

</style>